export const createDynamicComponentResolver = () => {
    // 预加载所有可能的组件
    const modules = import.meta.glob('../views/**/*.vue')
    const layoutModules = import.meta.glob('../layouts/**/*.vue')

    // 合并所有模块
    const allModules = { ...modules, ...layoutModules }
    console.log(allModules)
    // 创建路径映射
    const pathMap: Record<string, () => Promise<any>> = {}

    Object.keys(allModules).forEach(path => {
        // 提取相对路径并创建映射
        // 例如：'../../views/User/List.vue' -> 'User/List'
        const relativePath = path
            .replace('../views/', 'views/')
            .replace('../layouts/', 'layouts/')

        pathMap[relativePath] = allModules[path]
    })

    console.log('可用组件路径:', Object.keys(pathMap))

    return (componentPath: string) => {
        console.log('componentPath', componentPath)
        // 先尝试直接匹配
        if (pathMap[componentPath]) {
            return pathMap[componentPath]
        }

        // 尝试添加 layouts/ 前缀
        if (componentPath.includes('RouteView') || componentPath.includes('Layout')) {
            const layoutPath = `layouts/${componentPath}`
            if (pathMap[layoutPath]) {
                return pathMap[layoutPath]
            }
        }

        console.warn(`组件未找到: ${componentPath}，可用路径:`, Object.keys(pathMap))
        return () => import('@/views/exception/404.vue')
    }
}

export default createDynamicComponentResolver
